import {e2p} from "./convertNumbersLocale";
import JM from "jalali-moment";
// https://gitlab.com/hp-projects-code/vidaneh/react/-/blob/master/vidaneh/src/utils/Functions.js
const timeAgo = (value: string) => {
    const today = new Date();
    const valueDate = new Date(value);
    const timeDiff = Math.abs(valueDate.getTime() - today.getTime());
    if (timeDiff < (3600000)) {
        return e2p(Math.round(timeDiff / (60000)).toString()) + " دقیقه قبل";
    } else if (timeDiff >= (3600000) && timeDiff < (86400000)) {
        return e2p(Math.round(timeDiff / (3600000)).toString()) + " ساعت قبل";
    } else if (timeDiff >= (86400000) && timeDiff < (604800000)) {
        return e2p(Math.round(timeDiff / (86400000)).toString()) + " روز پیش";
    } else if (timeDiff >= (604800000) && timeDiff < (2419200000)) {
        return e2p(Math.round(timeDiff / (604800000)).toString()) + " هفته پیش";
    } else if (timeDiff >= (2419200000) && timeDiff < (7257600000)) {
        return e2p(Math.round(timeDiff / (2419200000)).toString()) + " ماه پیش";
    } else if (timeDiff >= (7257600000)) {
        return " سال " + e2p(Number(JM(value).format("jYYYY")).toString());
    }
}

export default timeAgo